import { List, Map } from 'immutable';

import { getSize } from '../../../iterable/getSize';

import { OPERATIONS } from '../../../../constants/bulkEdit';
import { ATTRIBUTE } from '../../../../constants/attributes';

export function collections({ channel, preview }) {
  const value = preview.get(ATTRIBUTE.COLLECTIONS);
  const payload = Map({ type: OPERATIONS[channel].COLLECTIONS, value: getSize(value) > 0 ? value : List(['']) });

  return { payload };
}
